import { createRouter, createWebHistory } from 'vue-router'
import {
  TG_APP_TYPE,
  appType,
  isFromShortLink,
  isReferralEarnApp,
  productType,
  referralEarnNewGuideTaskKey
} from '@/constants/index'
import { seoReport } from 'web-biz/reportEvent'
import http from '../apis/request'
import { isGuestLogin, isLogin, isTGPlatform } from '../utils'
import { nextTick } from 'vue'

const Home = () => import('@/pages/home/index.vue')
const Task = () => import('@/pages/task/index.vue')
const Search = () => import('@/pages/search/index.vue')
const DevTransfer = () => import('@/pages/devTransfer/index.vue')
const withdraw = () => import('@/pages/withdraw/index.vue')
const OpenTaurus = () => import('@/pages/openTaurus/index.vue')

const Asset = () => import('@/pages/myAsset/index.vue')
const AssetIndex = () => import('@/pages/myAsset/Home.vue')

const WithdrawMethod = () => import('@/pages/myAsset/withdraw/WithdrawMethod.vue')
const Withdraw = () => import('@/pages/myAsset/withdrawBank/Home.vue')
const AddWithdraw = () => import('@/pages/myAsset/withdrawBank/MobileBankForm.vue')
const Record = () => import('@/pages/myAsset/record/Home.vue')

const Coin = () => import('@/pages/coin/index.vue')
const CoinHome = () => import('@/pages/coin/home/index.vue')
const CoinWithdraw = () => import('@/pages/coin/withdraw/index.vue')
const CoinWithdrawRecord = () => import('@/pages/coin/withdrawRecord/index.vue')
const AdMid = () => import('@/pages/coin/adMid/index.vue')

const Box = () => import('@/pages/box/index.vue')
const BoxHome = () => import('@/pages/box/home/index.vue')
const BoxWithdraw = () => import('@/pages/box/withdraw/index.vue')
const BoxWithdrawRecord = () => import('@/pages/box/withdrawRecord/index.vue')

const Spin = () => import('@/pages/spin/index.vue')
const SpinHome = () => import('@/pages/spin/home/index.vue')
const SpinWelcome = () => import('@/pages/spin/welcome/index.vue')
const SpinWithdraw = () => import('@/pages/spin/withdraw/index.vue')

const WheelDraw = () => import('@/pages/wheelDraw/index.vue')
const WheelDrawHome = () => import('@/pages/wheelDraw/Home.vue')

const WinningRecord = () => import('@/pages//winRecord/index.vue')
const DownloadPage = () => import('@/pages/download/index.vue')

const WheelDrawSlot = () => import('@/pages/slotmach/index.vue')
const WheelDrawSlotHome = () => import('@/pages/slotmach/Home.vue')

const TaskChallenge = () => import('@/pages/taskChallenge/index.vue')
const TaskChallengeHome = () => import('@/pages/taskChallenge/home/index.vue')

const SmsSlot = () => import('@/pages/sms/index.vue')
const SmsSlotHome = () => import('@/pages/sms/Home.vue')

const ShareMaster130 = () => import('@/pages/share/master130.vue')

const Agent = () => import('@/pages/agent/index.vue')
const AgentHome = () => import('@/pages/agent/home/index.vue')
const AgentTask = () => import('@/pages/agent/task/index.vue')

const Battle = () => import('@/pages/battle/index.vue')
const BattleHome = () => import('@/pages/battle/home/index.vue')

const YoutubeOut = () => import('@/pages/youtubeOut/index.vue')

const YoutubeOutOld = () => import('@/pages/YoutubeOutOld/index.vue')

const Giveaway = () => import('@/pages/giveaway/index.vue')

const Master = () => import('@/pages/product/master/index.vue')
const MasterProductTemplate1 = () => import('@/pages/product/master/product/template1.vue')
const MasterProductTemplate2 = () => import('@/pages/product/master/product/template2.vue')
const MasterProductTemplate3 = () => import('@/pages/product/master/product/template3.vue')

const Bolly = () => import('@/pages/product/bolly/index.vue')
const BollyProductTemplate1 = () => import('@/pages/product/bolly/product/template1.vue')
const BollyProductTemplate2 = () => import('@/pages/product/bolly/product/template2.vue')
const BollyProductTemplate3 = () => import('@/pages/product/bolly/product/template3.vue')
const BollyProductTemplate4 = () => import('@/pages/product/bolly/product/template4.vue')
const BollyProductTemplate5 = () => import('@/pages/product/bolly/product/template5.vue')
const BollyProductTemplate6 = () => import('@/pages/product/bolly/product/template6.vue')

const Master130 = () => import('@/pages/product/master130/index.vue')
const Master130ProductTemplate = () => import('@/pages/product/master130/product/template.vue')

const Gold130 = () => import('@/pages/product/gold130/index.vue')
const Gold130ProductTemplate1 = () => import('@/pages/product/gold130/product/template1.vue')
const Gold130ProductTemplate2 = () => import('@/pages/product/gold130/product/template2.vue')
const Gold130ProductTemplate3 = () => import('@/pages/product/gold130/product/template3.vue')

const ReferralEarn = () => import('@/pages/referralEarn/index.vue')
const ReferralEarnTask = () => import('@/pages/referralEarn/task/index.vue')
const ReferralEarnLanding = () => import('@/pages/referralEarn/landing/index.vue')
const ReferralEarnTaskDetail = () => import('@/pages/referralEarn/task/detail/index.vue')
const ReferralEarnTeam = () => import('@/pages/referralEarn/team/index.vue')
const ReferralEarnWallet = () => import('@/pages/referralEarn/wallet/index.vue')

const ReferralEarnLogin = () => import('@/pages/referralEarn/login/index.vue')
const ReferralEarnTerms = () => import('@/pages/referralEarn/terms/index.vue')
const ReferralEarnPrivacy = () => import('@/pages/referralEarn/privacy/index.vue')

const TgRedirect = () => import('@/pages/tgRedirect/index.vue')

const commonRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/task',
    name: 'Task',
    component: Task,
    meta: { themeColor: '#fff' }
  },
  {
    path: '/search',
    component: Search
  },
  {
    path: '/devTransfer',
    component: DevTransfer
  },
  {
    path: '/spin/welcome',
    name: 'SpinWelcome',
    component: SpinWelcome
  },
  {
    path: '/m130',
    name: 'ShareMaster130',
    component: ShareMaster130
  },
  {
    path: '/withdraw',
    name: 'PwaWithdraw',
    component: withdraw
  },
  {
    path: '/ota',
    name: 'OpenTaurus',
    component: OpenTaurus
  }
]

const assetRoutes = {
  path: '/asset',
  component: Asset,
  noSeo: true,
  children: [
    {
      path: '',
      name: 'AssetIndex',
      component: AssetIndex,
      meta: { themeColor: '#018f46', noSeo: true }
    },
    {
      path: 'method',
      component: WithdrawMethod,
      name: 'WithdrawMethod',
      meta: { themeColor: '#018f46', noSeo: true }
    },
    {
      path: 'withdraw',
      component: Withdraw,
      name: 'Withdraw',
      meta: { themeColor: '#fff', noSeo: true }
    },
    {
      path: 'addWithdraw',
      component: AddWithdraw,
      name: 'AddWithdraw',
      meta: { themeColor: '#fff', noSeo: true }
    },
    { path: 'record', component: Record, name: 'Record', meta: { themeColor: '#fff', noSeo: true } }
  ]
}

const coinRoutes = {
  path: '/coin',
  component: Coin,
  children: [
    {
      path: '',
      redirect: '/',
      name: 'CoinHome',
      component: CoinHome,
      meta: { themeColor: '#0096FF' }
    },
    {
      path: 'withdraw',
      name: 'CoinWithdraw',
      component: CoinWithdraw,
      meta: { themeColor: '#2EB221', noSeo: true }
    },
    {
      path: 'withdrawRecord',
      name: 'CoinWithdrawRecord',
      component: CoinWithdrawRecord,
      meta: { themeColor: '#fff', noSeo: true }
    },
    {
      path: 'mid',
      name: 'AdMid',
      component: AdMid,
      meta: { themeColor: '#fff', noSeo: true }
    }
  ]
}
const spinRoutes = {
  path: '/spin',
  component: Spin,
  meta: { noSeo: true },
  children: [
    { path: '', name: 'SpinHome', component: SpinHome, meta: { noSeo: true } },
    {
      path: 'withdraw',
      name: 'SpinWithdraw',
      component: SpinWithdraw,
      meta: { themeColor: '#2EB221', noSeo: true }
    }
  ]
}
const winRecordRoutes = {
  path: '/winRecord',
  name: 'WinRecord',
  component: WinningRecord,
  meta: { themeColor: '#fff' }
}

const downloadRoutes = {
  path: '/download/:no',
  name: 'DownloadPage',
  component: DownloadPage,
  meta: { themeColor: '#fff' }
}

const wheelDrawRoutes = {
  path: '/wheeldraw',
  component: WheelDraw,
  children: [{ path: '', name: 'WheelDrawHome', component: WheelDrawHome }]
}

const wheelDrawSlotRoutes = {
  path: '/slot',
  component: WheelDrawSlot,
  children: [{ path: '', name: 'WheelDrawSlotHome', component: WheelDrawSlotHome }]
}

const smsRoutes = {
  path: '/sms',
  component: SmsSlot,
  children: [{ path: '', name: 'SmsSlotHome', component: SmsSlotHome }]
}

const boxRoutes = {
  path: '/box',
  component: Box,
  children: [
    {
      path: '',
      redirect: '/',
      name: 'BoxHome',
      component: BoxHome,
      meta: { themeColor: '#0096FF' }
    },
    {
      path: 'withdraw',
      redirect: '/',
      name: 'BoxWithdraw',
      component: BoxWithdraw,
      meta: { themeColor: '#2EB221' }
    },
    {
      path: 'withdrawRecord',
      redirect: '/',
      name: 'BoxWithdrawRecord',
      component: BoxWithdrawRecord,
      meta: { themeColor: '#fff' }
    }
  ]
}
const taskChallengeRoutes = {
  path: '/challenge',
  component: TaskChallenge,
  children: [{ path: '', name: 'TaskChallengeHome', component: TaskChallengeHome }]
}

const agentRoute = {
  path: '/agent',
  component: Agent,
  children: [
    { path: '', name: 'AgentHome', component: AgentHome },
    {
      path: 'task',
      name: 'AgentTask',
      component: AgentTask
    },
    {
      path: 'withdraw',
      name: 'AgentWithdraw',
      component: SpinWithdraw,
      meta: { themeColor: '#2EB221' }
    }
  ]
}

// KOL PK活动
const battleRoutes = {
  path: '/battle',
  component: Battle,
  children: [{ path: '', name: 'BattleHome', component: BattleHome }]
}

//youtube视频上传
const videoRoutes = {
  path: '/',
  name: 'YoutubeOut',
  component: YoutubeOut,
  meta: { noSeo: true }
}

// giveaway
const giveawayRoutes = [
  {
    path: '/lifafa/scratch',
    name: 'Giveaway',
    component: Giveaway,
    meta: { noSeo: true }
  },
  {
    path: '/',
    redirect: '/lifafa/scratch'
  }
]

const oldVideoRoutes = {
  path: '/out',
  name: 'YoutubeOutOld',
  component: YoutubeOutOld,
  meta: { noSeo: true }
}

// 网赚
const referralEarnRoutes = [
  {
    path: '/',
    redirect: '/landing'
  },
  {
    path: '/login',
    name: 'ReferralEarnLogin',
    component: ReferralEarnLogin,
    meta: { noSeo: true, themeColor: '#1e62f3' }
  },
  {
    path: '/terms',
    name: 'ReferralEarnTerms',
    component: ReferralEarnTerms,
    meta: { noSeo: true, themeColor: '#1e62f3' }
  },
  {
    path: '/privacy',
    name: 'ReferralEarnPrivacy',
    component: ReferralEarnPrivacy,
    meta: { noSeo: true, themeColor: '#1e62f3' }
  },
  {
    path: '/out',
    name: 'ReferralEarnYoutubeOut',
    component: YoutubeOut,
    meta: { noSeo: true, themeColor: '#1e62f3' }
  },
  {
    path: '/landing',
    name: 'ReferralEarnLanding',
    component: ReferralEarnLanding,
    meta: { noSeo: true, themeColor: '#1e62f3' }
  },
  {
    path: '/task/detail',
    name: 'ReferralEarnTaskDetail',
    component: ReferralEarnTaskDetail,
    meta: { noSeo: true, themeColor: '#1e62f3', requiresAuth: true }
  },
  {
    path: '/',
    component: ReferralEarn,
    children: [
      {
        path: 'task',
        name: 'ReferralEarnTask',
        component: ReferralEarnTask,
        meta: { noSeo: true, themeColor: '#1e62f3', requiresAuth: true }
      },
      {
        path: 'team',
        name: 'ReferralEarnTeam',
        component: ReferralEarnTeam,
        meta: { noSeo: true, themeColor: '#1e62f3', requiresAuth: true }
      },
      {
        path: 'wallet',
        name: 'ReferralEarnWallet',
        component: ReferralEarnWallet,
        meta: { noSeo: true, themeColor: '#1e62f3', requiresAuth: true }
      }
    ]
  }
]

// master30落地页
const masterRoutes = {
  path: '/master',
  component: Master,
  redirect: (to) => {
    const g = to.query.g || 1
    return {
      path: `/master/tpl${g}`,
      query: {
        t: to.query.t,
        c: to.query.c,
        sf: to.query.sf,
        channel: to.query.channel
      }
    }
  },
  meta: { noSeo: true },
  children: [
    {
      path: 'tpl1',
      name: 'MasterProductTemplate1',
      component: MasterProductTemplate1,
      meta: { noSeo: true }
    },
    {
      path: 'tpl2',
      name: 'MasterProductTemplate2',
      component: MasterProductTemplate2,
      meta: { noSeo: true }
    },
    {
      path: 'tpl3',
      name: 'MasterProductTemplate3',
      component: MasterProductTemplate3,
      meta: { noSeo: true }
    }
  ]
}

// bollygame落地页
const bollyRoutes = {
  path: '/bolly',
  component: Bolly,
  redirect: (to) => {
    const g = to.query.g || 1
    return {
      path: `/bolly/tpl${g}`,
      query: {
        t: to.query.t,
        c: to.query.c,
        sf: to.query.sf,
        channel: to.query.channel
      }
    }
  },
  meta: { noSeo: true },
  children: [
    {
      path: 'tpl1',
      name: 'BollyProductTemplate1',
      component: BollyProductTemplate1,
      meta: { noSeo: true }
    },
    {
      path: 'tpl2',
      name: 'BollyProductTemplate2',
      component: BollyProductTemplate2,
      meta: { noSeo: true }
    },
    {
      path: 'tpl3',
      name: 'BollyProductTemplate3',
      component: BollyProductTemplate3,
      meta: { noSeo: true }
    },
    {
      path: 'tpl4',
      name: 'BollyProductTemplate4',
      component: BollyProductTemplate4,
      meta: { noSeo: true }
    },
    {
      path: 'tpl5',
      name: 'BollyProductTemplate5',
      component: BollyProductTemplate5,
      meta: { noSeo: true }
    },
    {
      path: 'tpl6',
      name: 'BollyProductTemplate6',
      component: BollyProductTemplate6,
      meta: { noSeo: true }
    }
  ]
}

// master130落地页
const master130Routes = {
  path: '/master130',
  component: Master130,
  redirect: (to) => {
    const g = to.query.g || 1
    return {
      path: `/master130/tpl${g}`,
      query: {
        t: to.query.t,
        c: to.query.c,
        sf: to.query.sf,
        channel: to.query.channel
      }
    }
  },
  meta: { noSeo: true },
  children: [
    {
      path: 'tpl1',
      name: 'Master130ProductTemplate',
      component: Master130ProductTemplate,
      meta: { noSeo: true }
    }
  ]
}

// Gold130落地页
const gold130Routes = {
  path: '/gold130',
  component: Gold130,
  redirect: (to) => {
    const g = to.query.g || 1
    return {
      path: `/gold130/tpl${g}`,
      query: {
        t: to.query.t,
        c: to.query.c,
        sf: to.query.sf,
        channel: to.query.channel
      }
    }
  },
  meta: { noSeo: true },
  children: [
    {
      path: 'tpl1',
      name: 'Gold130ProductTemplate1',
      component: Gold130ProductTemplate1,
      meta: { noSeo: true }
    },
    {
      path: 'tpl2',
      name: 'Gold130ProductTemplate2',
      component: Gold130ProductTemplate2,
      meta: { noSeo: true }
    },
    {
      path: 'tpl3',
      name: 'Gold130ProductTemplate3',
      component: Gold130ProductTemplate3,
      meta: { noSeo: true }
    }
  ]
}

// tg中转页，用于在tg内部浏览器缓存code
const tgRedirectRoute = {
  path: '/tgredirect',
  name: 'TgRedirect',
  component: TgRedirect,
  meta: { noSeo: true }
}

const notFoundRoutes = (defaultRoute = commonRoutes[0]) => {
  return {
    path: '/:pathMatch(.*)*',
    redirect: defaultRoute.path
  }
}
/**
 * 要看每个端（应用类型）具体要包含哪些模块，在路由配置上，只配置其需要的模块
 * @returns 结果路由数组
 */
function generateRoutes() {
  let productRoute = {}
  switch (productType) {
    case 'master':
      productRoute = masterRoutes
      break
    case 'bolly':
      productRoute = bollyRoutes
      break
    case 'master130':
      productRoute = master130Routes
      break
    case 'gold130':
      productRoute = gold130Routes
      break
    default:
      productRoute = masterRoutes
  }
  // 来自短链后台只有落地页路由
  if (isFromShortLink) {
    return [
      productRoute,
      {
        path: '/:pathMatch(.*)*',
        redirect: productRoute.path
      }
    ]
  }
  let tgAppRoutes = []
  if (['spin', 'coin'].includes(TG_APP_TYPE)) {
    tgAppRoutes = [assetRoutes, agentRoute]
  }
  if (TG_APP_TYPE == 'spin') {
    return [spinRoutes, ...tgAppRoutes, notFoundRoutes(spinRoutes)]
  }
  if (TG_APP_TYPE == 'coin') {
    return [coinRoutes, ...tgAppRoutes, notFoundRoutes(coinRoutes)]
  }
  // 网赚
  if (appType === 'referralEarn') {
    return [...referralEarnRoutes, assetRoutes, notFoundRoutes(referralEarnRoutes[0])]
  }
  if (appType == 'out') {
    return [videoRoutes, notFoundRoutes(videoRoutes)]
  }
  if (appType == 'giveaway') {
    return [assetRoutes, ...giveawayRoutes, notFoundRoutes(giveawayRoutes[0])]
  }
  return [
    ...commonRoutes,
    assetRoutes,
    boxRoutes,
    coinRoutes,
    winRecordRoutes,
    downloadRoutes,
    wheelDrawRoutes,
    wheelDrawSlotRoutes,
    taskChallengeRoutes,
    smsRoutes,
    battleRoutes,
    oldVideoRoutes,
    productRoute,
    tgRedirectRoute,
    notFoundRoutes()
  ]
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: generateRoutes()
})
router.beforeEach((to, _, next) => {
  const themeColor = to.meta.themeColor || '#6ED140'
  document.querySelector('meta[name="theme-color"]').setAttribute('content', themeColor)
  if (isReferralEarnApp) {
    dealReferralEarnAppRoute(to, next)
    return
  }
  next()
})

function dealReferralEarnAppRoute(to, next) {
  const safeRoute = ['/login', '/landing', '/terms', '/privacy']
  const taskRoute = ['/task', '/task/detail', '/login']
  const guestLogin = isGuestLogin()
  const isFinishedNewTask = localStorage.getItem(referralEarnNewGuideTaskKey) == 1
  if (!guestLogin) {
    if (safeRoute.includes(to.path)) {
      next()
      return
    }
    next({ path: '/landing', query: to.query })
    return
  }
  if (!isFinishedNewTask) {
    if (taskRoute.includes(to.path)) {
      next()
      return
    }
    next({ path: '/task', query: to.query })
    return
  }
  next()
}
router.afterEach((to) => {
  nextTick(() => {
    const noSeoAppTyps = ['out', 'referralEarn']
    if (!to.meta?.noSeo && !isTGPlatform() && !noSeoAppTyps.includes(appType)) {
      requestAnimationFrame(() => {
        seoReport(http)
      })
    }
  })
})
export default router
